"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _ConfirmationModal = _interopRequireDefault(require("@insided/shared/uikit/Modal/ConfirmationModal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var USER_LANGUAGE_PREFERENCE_SET_KEY = 'languagePreference';
var cssAnchorName = 'language-preference-modal';
exports.cssAnchorName = cssAnchorName;

var DetectBrowserLanguageModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DetectBrowserLanguageModal, _Component);

  var _super = _createSuper(DetectBrowserLanguageModal);

  function DetectBrowserLanguageModal() {
    var _this;

    (0, _classCallCheck2.default)(this, DetectBrowserLanguageModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isModalOpen: false,
      detectedLocaleDisplayName: '',
      detectedLanguageCode: '',
      detectedLocaleCode: '',
      userPreferenceSet: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var storedLanguagePreferenceSet, userPreferenceSet, detectedBrowserLocale, formattedDetectedBrowserLocale, showSetLanguagePreferenceModal, paramsData, _yield$axios$get, data, defaultCommunityLocale, detectedLocaleCode;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              storedLanguagePreferenceSet = window.localStorage.getItem(USER_LANGUAGE_PREFERENCE_SET_KEY);

              if (storedLanguagePreferenceSet) {
                userPreferenceSet = JSON.parse(storedLanguagePreferenceSet);

                _this.setState({
                  userPreferenceSet: userPreferenceSet
                });
              } // user has selected preference, return


              if (!_this.state.userPreferenceSet) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              detectedBrowserLocale = navigator.language;
              formattedDetectedBrowserLocale = detectedBrowserLocale.includes('-') ? detectedBrowserLocale.replace('-', '_') : detectedBrowserLocale;
              showSetLanguagePreferenceModal = false;
              paramsData = {
                detectedLocale: formattedDetectedBrowserLocale
              }; // Check if locale cookie is set, fetch display name of detected browser language, check if detected language is
              // published

              _context.next = 10;
              return _axios.default.get('/user/locale', {
                params: paramsData
              });

            case 10:
              _yield$axios$get = _context.sent;
              data = _yield$axios$get.data;

              if (!data.isDetectedLocalePublished) {
                _context.next = 23;
                break;
              }

              if (!(data.locale === '')) {
                _context.next = 22;
                break;
              }

              defaultCommunityLocale = data.defaultCommunityLocale;
              detectedLocaleCode = data.detectedLocaleCode;
              showSetLanguagePreferenceModal = defaultCommunityLocale !== detectedLocaleCode; // save locale to cookie

              if (!(defaultCommunityLocale === detectedLocaleCode)) {
                _context.next = 20;
                break;
              }

              _context.next = 20;
              return _this.saveLocaleToCookie(detectedLocaleCode);

            case 20:
              _context.next = 23;
              break;

            case 22:
              if (data.locale !== data.detectedLocaleCode) {
                // If locale cookie was set and is different from detected browser language - show modal to set
                // language preference
                showSetLanguagePreferenceModal = true;
              } else {
                // If locale cookie was set and is same as detected browser language - do not show modal but set user
                // preference as selected
                _this.setUserPreference(true);
              }

            case 23:
              _this.setState({
                detectedLocaleDisplayName: data.detectedLocaleDisplayName,
                detectedLanguageCode: data.detectedLanguageCode,
                detectedLocaleCode: data.detectedLocaleCode,
                isModalOpen: showSetLanguagePreferenceModal
              });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveLocaleToCookie", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(detectedLocale) {
        var params;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  detectedLocale: detectedLocale
                };
                _context2.next = 3;
                return _axios.default.post('/user/locale', {
                  params: params
                });

              case 3:
                _this.setUserPreference(true);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setUserPreference", function (value) {
      window.localStorage.setItem(USER_LANGUAGE_PREFERENCE_SET_KEY, JSON.stringify(value));

      _this.setState({
        isModalOpen: false,
        userPreferenceSet: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClose", function () {
      _this.setUserPreference(true);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectPreferredLanguage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$state, detectedLocaleCode, detectedLanguageCode, currentUrlQuery, redirectUrl;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state = _this.state, detectedLocaleCode = _this$state.detectedLocaleCode, detectedLanguageCode = _this$state.detectedLanguageCode;
              _context3.next = 3;
              return _this.saveLocaleToCookie(detectedLocaleCode);

            case 3:
              currentUrlQuery = new URLSearchParams(window.location.search);

              if (detectedLanguageCode) {
                currentUrlQuery.set('lang', String(detectedLanguageCode));
              }

              redirectUrl = window.location.pathname + '?' + currentUrlQuery.toString();
              window.location.replace(_resolveUrl((0, _absoluteUrlRuntime.resolveUrl)(redirectUrl)));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickLogin", function () {
      _this.setState({
        isModalOpen: false
      });

      if (_this.props.ssoLoginUrl) return;
      window.app.events.commands.execute('modal:login:show');
    });
    return _this;
  }

  (0, _createClass2.default)(DetectBrowserLanguageModal, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isModalOpen = _this$state2.isModalOpen,
          detectedLocaleDisplayName = _this$state2.detectedLocaleDisplayName;
      var _this$props = this.props,
          ssoLoginUrl = _this$props.ssoLoginUrl,
          loginPhrase = _this$props.loginPhrase;
      return (0, _preact.h)(_ConfirmationModal.default, {
        isOpen: isModalOpen,
        isControl: false,
        size: "small",
        handleConfirmation: this.onSelectPreferredLanguage,
        placement: "top-right",
        onClose: this.onClose,
        title: "Your preferred language",
        theme: "language-preference",
        body: (0, _preact.h)("div", null, (0, _preact.h)("div", null, "We identified ", detectedLocaleDisplayName, " to be your browser language."), (0, _preact.h)("div", null, (0, _preact.h)("a", {
          role: "button",
          tabIndex: 2,
          href: (0, _absoluteUrlRuntime.resolveUrl)(ssoLoginUrl || '#'),
          onClick: this.onClickLogin
        }, ' ', loginPhrase), ' ', "to set this as preferred language.")),
        footer: (0, _preact.h)("button", {
          className: "btn btn--cta",
          tabIndex: 2,
          onClick: this.onSelectPreferredLanguage,
          type: "button"
        }, "Switch to ".concat(detectedLocaleDisplayName))
      });
    }
  }]);
  return DetectBrowserLanguageModal;
}(_preact.Component);

var _default = DetectBrowserLanguageModal;
exports.default = _default;